import axios from 'axios';

import type { GetListConversationsResult } from './request';

export type ListConversationsClientApiCall = (params?: { cursor?: string }) => Promise<GetListConversationsResult>;

const AI_COMPANION_LIST_CONVERSATIONS_ENDPOINT = '/api/ai-companion/list-conversations';

export const listConversationsApi: ListConversationsClientApiCall = async (params) => {
	const res = await axios.get(AI_COMPANION_LIST_CONVERSATIONS_ENDPOINT, { params });
	return res.data;
};
